import { render, staticRenderFns } from "./sportsCause.vue?vue&type=template&id=77a13893&"
import script from "./sportsCause.vue?vue&type=script&lang=js&"
export * from "./sportsCause.vue?vue&type=script&lang=js&"
import style0 from "./sportsCause.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports